import { FC } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

/**
 * @Description 节点意见
 */
const NodeOpinion: FC<{
  /** 意见 */
  text: any;
  /** 是否是发起节点 */
  isStart: boolean;
}> = ({
  text, // 意见
  isStart, // 是否是发起节点
}) => {

  return (
    <V2DetailItem
      label=''
    >
      <div
        className={cs(
          styles.opinionCon,
          isStart ? styles.isStart : '',
          'c-222 fs-14'
        )}
      >
        {text}
      </div>
    </V2DetailItem>
  );
};

export default NodeOpinion;
